import { useTranslation } from "next-i18next";
import Link from "next/link";
import { getRelativeImagePath } from "../../../util/helper/getRelativeImagePath";

function ReadMoreContent() {
  const { t } = useTranslation("common");
  return (
    <h4 className="p-b-5 p-t-5">{t("Read more")}</h4>
  );
}

function SpeedRating() {
  const { t } = useTranslation("common");
  return (
    <div style={{ width: 250 }} className="d-flex flex-column align-items-right">
      {t("speed_rating_popover_content")}

      <Link
        href="/understanding-tire-sidewall-readings"
        style={{ textAlign: "right" }}
      >

        <ReadMoreContent />

      </Link>
    </div>
  );
}

function TireSize() {
  return (
    <div className="d-flex justify-content-center flex-column text-align-right" style={{ width: 250 }}>

      <img src={getRelativeImagePath("/images/tires/tire-size-preview.png")} alt="tire size detail" style={{ width: 250 }} />

      <Link
        href="/understanding-tire-sidewall-readings"
        style={{ textAlign: "right" }}
      >

        <ReadMoreContent />

      </Link>
    </div>
  );
}

function WheelsOffset() {
  const { t } = useTranslation("common");
  return (
    <div className="d-flex justify-content-center flex-column text-align-right">
      {t("wheel_offset_popover_content")}

      <Link href="/what-is-wheel-offset" style={{ textAlign: "right" }}>

        <ReadMoreContent />

      </Link>
    </div>
  );
}

// const VALID_POPUP_ELEMENTS = ["offset", "size", "speedRating", "widthInMm"];

const UI_VALUE = {
  speedRating: <SpeedRating />,
  widthInMm: <TireSize />,
  offset: <WheelsOffset />,
};

export function needPopOver(key: any) {
  return UI_VALUE[key] || null;
}
